export default __webpack_public_path__ + "static/AppCV1-886b106c3a2fbbed527f37ac639b245f.png";